export var SkillType;
(function (SkillType) {
    SkillType["SOFT_SKILL"] = "Soft skills";
})(SkillType || (SkillType = {}));
export var createSkillsApi = function (baseUrl, http) {
    var api = {
        getSkills: function () { return http.get(baseUrl + "/skills"); },
        getSpecificSkill: function (dto) { return http.get(baseUrl + "/skills/" + dto.id); },
        deleteSkill: function (dto) { return http.delete(baseUrl + "/skills/" + dto.id); },
        addSkill: function (dto) { return http.post(baseUrl + "/skills/", dto); },
        updateAgentSkillsAssignment: function (dto) { return http.put(baseUrl + "/agents/" + dto.agentId + "/skillIds", { skillIds: dto.assignedSkills }); },
        deleteAgentSkills: function (dto) { return http.delete(baseUrl + "/agents/" + dto.id + "/skillIds"); }
    };
    return api;
};
//# sourceMappingURL=index.js.map